
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InputWrapper',
  props: {
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      required: true
    },
    inputWidth: {
      type: String,
      default: 'small'
    },
    removeYPadding: {
      type: Boolean,
      default: false
    },
    cascadeInput: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gridClass(): string {
      if (this.inputWidth === 'xx-small') return 'grid-cols-1 md:grid-cols-fr-8'
      if (this.inputWidth === 'x-small') return 'grid-cols-1 md:grid-cols-fr-12'
      if (this.inputWidth === 'small') return 'grid-cols-1 md:grid-cols-fr-16'
      if (this.inputWidth === 'base') return 'grid-cols-1 md:grid-cols-fr-20'
      if (this.inputWidth === 'wide') return 'grid-cols-1 md:grid-cols-fr-24'

      return 'grid-cols-fr-16'
    }
  }
})
